/**
 * Select Component
 *
 * Reusable dropdown select with consistent styling
 * - Error state
 * - Disabled state
 * - Placeholder support
 * - Size variants
 */

import React from "react";
import PropTypes from "prop-types";
import "./Select.scss";

export const Select = ({
  value,
  onChange,
  options = [],
  placeholder = "Select...",
  disabled = false,
  error = false,
  size = "medium",
  fullWidth = false,
  className = "",
  ...props
}) => {
  const selectClasses = [
    "select",
    `select--${size}`,
    error && "select--error",
    disabled && "select--disabled",
    fullWidth && "select--full-width",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={selectClasses}
      {...props}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
};

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default Select;
